<template>
  <div class="list-view submittal-tab" v-if="dataLoaded">
    <o-loading :full-page="true" :active="isLoading" :can-cancel="false" />
    <mf-table
      ref="submittalTable"
      :key="`submittals-public-${submittalId}`"
      :table-props="tableProps"
      :load-data="loadData"
      :hide-gutter="true"
      :screen-table="true"
      table-name="submittalsPublicTable"
    >
      <template #type="{ rowData }">
        {{ rowData.__t === 'Sourcing' ? 'Materials' : rowData.__t }}
      </template>
    </mf-table>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { isEmpty } from 'lodash';
import Procore from '@/models/Procore';
import tableProps from '@/components/table-cols/submittalCols';
import MfTable from '@/components/table-fields/MfTable.vue';

export default defineComponent({
  name: 'MfSubmittalPublicView',
  components: { MfTable },
  props: {
    submittalId: { type: String, default: '' },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const data = reactive({ tableProps, isLoading: false, isUserLoggedIn: false, dataLoaded: false });

    const loadData = async (commonParams = {}) => {
      data.isLoading = true;
      try {
        const submittalData = await Procore.getSubmitalOrders({
          isPublic: true,
          submittalId: props.submittalId,
          ...commonParams,
        });
        if (data.isUserLoggedIn && submittalData.data.length) {
          await router.push({
            name: 'submittals-private',
            params: { submittalId: submittalData.data[0].submittal.id },
          });
        }
        console.log('submittalData', submittalData);
        return { data: submittalData.data, total: submittalData.data.length };
      } finally {
        data.isLoading = false;
      }
    };

    onMounted(async () => {
      await store.dispatch('getUserData');
      await store.getters.userPromise;
      data.isUserLoggedIn = !isEmpty(store.state.userData);
      data.dataLoaded = true;
    });

    return { ...toRefs(data), loadData };
  },
});
</script>

